import { Ability, AbilityBuilder } from "@casl/ability";

import { USER_RANK_ADMIN, USER_RANK_NORMAL, USER_RANK_CONTREMAITRE, USER_RANK_NULL } from "constants/dbValues";

export function updateUserForAbilities(u) {
  var rank = parseInt((u.user_type || {}).rang || USER_RANK_NULL);
  if (!(rank in ABILITIES)) return;

  switch (rank) {
    case USER_RANK_ADMIN:
      ABILITIES[rank].update(defineRulesForAdmin(u));
      break;
    case USER_RANK_NORMAL:
    case USER_RANK_CONTREMAITRE:
      ABILITIES[rank].update(defineRulesForUser(u));
      break;
    default:
      break;
  }
}

function subjectName(item) {
  if (!item || typeof item === "string") {
    return item;
  }

  return item.__type;
}

const admin = new Ability(defineRulesForAdmin(), { subjectName });
const user = new Ability(defineRulesForUser(), { subjectName });
const contremaitre = new Ability(defineRulesForUser(), { subjectName });
const def = AbilityBuilder.define({ subjectName }, (can) => {});

function defineRulesForAdmin(user) {
  const { can, rules } = AbilityBuilder.extract();
  if (!user) user = JSON.parse(localStorage.getItem("user"));

  can(["read", "read_admin"], "General");
  can(["read", "edit", "create"], "Client");
  can(["read", "edit", "create"], "Compliance");
  can(["read", "create", "delete"], "Document");
  can(["read", "edit", "create"], "Incident");
  can(["read", "edit", "create"], "Note");
  can(["read", "edit", "create"], "Project");
  can(["read", "edit", "create"], "Tailgate");
  can(["read", "edit", "create"], "Submission");
  can(["read", "edit", "create", "edit_type", "disable"], "User");

  return rules;
}

function defineRulesForUser(user) {
  const { can, rules } = AbilityBuilder.extract();
  if (!user) user = JSON.parse(localStorage.getItem("user"));

  can(["read"], "General");
  can(["read"], "Client");
  can(["read", "create"], "Compliance");
  can(["read", "create"], "Document");
  can(["read", "create"], "Incident");
  can(["read", "create"], "Note");
  can(["read", "create"], "Project");
  can(["read", "create"], "Tailgate");
  can(["edit"], "Tailgate", { published: false });

  if (user) {
    can(["read", "edit"], "User", { id: user.id });
  }

  return rules;
}

export const ABILITIES = {
  [USER_RANK_ADMIN]: admin,
  [USER_RANK_NORMAL]: user,
  [USER_RANK_CONTREMAITRE]: contremaitre,
  [USER_RANK_NULL]: def,
  default: def,
};
